import { createSlice } from '@reduxjs/toolkit'

export const bidSlice = createSlice({
    name: "sheet",
    initialState: {
        updating: false,
    },
    reducers: {
        setUpdating: (state, action) => {
            state.updating = action.payload
        },
    }
})

export const {
    setUpdating,
} = bidSlice.actions


export const selectIsUpdating = (state) => state.sheet.updating

export default bidSlice.reducer
